import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useProfessors() {
    return useQuery({
        queryKey: ['professors'],
        queryFn: () => apiClient('/professors'),
        staleTime: 1000 * 60 * 3,
    });
}
export function useCreateProfessor() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient('/professors', { method: 'POST', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['professors'] }),
    });
}
export function useUpdateProfessor(id) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (dto) => apiClient(`/professors/${id}`, { method: 'PATCH', body: JSON.stringify(dto) }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['professors'] }),
    });
}
export function useDeleteProfessor() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id) => apiClient(`/professors/${id}`, { method: 'DELETE' }),
        onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['professors'] }),
    });
}
export function useSendProfessorPasswordReset() {
    return useMutation({
        mutationFn: (id) => apiClient(`/professors/${id}/password-reset`, { method: 'POST' }),
    });
}
//# sourceMappingURL=useProfessors.js.map